import { createSelector } from 'reselect';
import { List as iList } from 'immutable';

const anchorSamples = (state) => state.get('anchorSamples', iList());

export const anchorSamplesSelector = createSelector(
  [anchorSamples],
  (anchorSamples) => anchorSamples,
);
